import { useCallback, useRef, useState } from 'react';
import { Animated } from 'react-native';

import Placeholder from '../../../elements/Placeholder';
import { navigate } from '../../../utils/navigationService';
import routeUtils from '../../../utils/routes';
import styles, {
  ONBOARDING_IMAGE_HEIGHT,
  ONBOARDING_IMAGE_WIDTH,
  S,
} from './styles';

interface Props {
  showLoading: boolean;
  testID?: string;
}

const logData = [
  {
    actionName: 'click_others',
    eventCategory: 'observation metric',
    eventLabel: 'index_newuserGift',
    nonInteraction: false,
  },
];

export default function OnboardingImage({ showLoading }: Props) {
  const loadingAnimated = useRef(new Animated.Value(1));
  const [isLoading, setIsLoading] = useState(true);

  const onLoadEnd = useCallback(() => {
    Animated.timing(loadingAnimated.current, {
      toValue: 0,
      duration: 300,
      useNativeDriver: false,
    }).start(() => setIsLoading(false));
  }, []);

  const onPress = useCallback(() => {
    navigate('OnboardingPage');
  }, []);

  return (
    <S.ImageContainer
      accessibilityRole="link"
      logData={logData}
      href={routeUtils.compileToPath('OnboardingPage')}
      onPress={onPress}
      testID="OnboardingImageContainer"
      disabled={showLoading}
    >
      {!showLoading && (
        <S.Image
          testID="OnboardingImage"
          source={require('./assets/btn_onboard_red_envelope.png')}
          onLoadEnd={onLoadEnd}
        />
      )}
      {isLoading && (
        <Animated.View
          testID="placeholderView"
          style={[
            styles.imagePlaceholderWrapper,
            {
              opacity: loadingAnimated.current,
            },
          ]}
        >
          <Placeholder
            width={ONBOARDING_IMAGE_WIDTH}
            height={ONBOARDING_IMAGE_HEIGHT}
          />
        </Animated.View>
      )}
    </S.ImageContainer>
  );
}
